/**
 * Copyright IBM Corp. 2022, 2026
 */

export const allSupportedLocales = [
	'en',
	'de',
	'es',
	'fr',
	'ja',
	'ko',
	'pt',
	'id',
	'zh',
	'it',
	'ar',
]
